import { useFormik } from "formik";
import httpClient from "../../../modules/httpClient";

export default function Submit({ submitMethod, submitUrl, data, validationSchema }) {
  return useFormik({
    initialValues: { ...data },
    validationSchema,
    validateOnChange: false,
    onSubmit: (values, actions) => {
      actions.setSubmitting(true);

      httpClient({
        method: submitMethod,
        url: submitUrl,
        data: { ...values },
      })
        .then((res) => {
          localStorage.setItem("token", res.data.accessToken);
          window.location.reload();
        })
        .catch((error) => {
          actions.setStatus(error.response ? error.response.data.data : "Ошибка сервера");
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    },
  });
}
